import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import './PasswordInput.css';

/**
 * Password field with show/hide toggle.
 * Pass `inputClassName` to match page styles (login-input, apply-input, etc.).
 */
export default function PasswordInput({
  value,
  onChange,
  onBlur,
  className = '',
  inputClassName = '',
  placeholder,
  autoComplete,
  name,
  required,
  minLength,
  id,
  disabled,
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`pw-wrap${className ? ` ${className}` : ''}`}>
      <input
        className={inputClassName}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        autoComplete={autoComplete}
        name={name}
        required={required}
        minLength={minLength}
        id={id}
        disabled={disabled}
      />
      <button
        type="button"
        className="pw-toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        tabIndex={-1}
      >
        {visible ? <EyeOff size={18} strokeWidth={2} aria-hidden /> : <Eye size={18} strokeWidth={2} aria-hidden />}
      </button>
    </div>
  );
}
